/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EditServceContentMapByLists } from '../model/editServceContentMapByLists';
import { NewServiceContentsMapDto } from '../model/newServiceContentsMapDto';
import { ProblemDetails } from '../model/problemDetails';
import { ServiceContentMap } from '../model/serviceContentMap';
import { ServiceContentMapServicesNameDto } from '../model/serviceContentMapServicesNameDto';
import { ServiceContentsMapDto } from '../model/serviceContentsMapDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServiceContentMapService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceContentMapCreateServiceContentMapPost(body?: NewServiceContentsMapDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiServiceContentMapCreateServiceContentMapPost(body?: NewServiceContentsMapDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiServiceContentMapCreateServiceContentMapPost(body?: NewServiceContentsMapDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiServiceContentMapCreateServiceContentMapPost(body?: NewServiceContentsMapDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/ServiceContentMap/CreateServiceContentMap`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceContentMapGetAllByContentIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceContentMapServicesNameDto>>;
    public apiServiceContentMapGetAllByContentIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceContentMapServicesNameDto>>>;
    public apiServiceContentMapGetAllByContentIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceContentMapServicesNameDto>>>;
    public apiServiceContentMapGetAllByContentIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceContentMapServicesNameDto>>('get',`${this.basePath}/api/ServiceContentMap/GetAllByContentId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceContentMapGetAllByServiceIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceContentsMapDto>>;
    public apiServiceContentMapGetAllByServiceIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceContentsMapDto>>>;
    public apiServiceContentMapGetAllByServiceIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceContentsMapDto>>>;
    public apiServiceContentMapGetAllByServiceIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceContentsMapDto>>('get',`${this.basePath}/api/ServiceContentMap/GetAllByServiceId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceContentMapGetAllByServiceNameGet(serviceName?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceContentsMapDto>>;
    public apiServiceContentMapGetAllByServiceNameGet(serviceName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceContentsMapDto>>>;
    public apiServiceContentMapGetAllByServiceNameGet(serviceName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceContentsMapDto>>>;
    public apiServiceContentMapGetAllByServiceNameGet(serviceName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceContentsMapDto>>('get',`${this.basePath}/api/ServiceContentMap/GetAllByServiceName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceContentMapGetAllGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceContentsMapDto>>;
    public apiServiceContentMapGetAllGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceContentsMapDto>>>;
    public apiServiceContentMapGetAllGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceContentsMapDto>>>;
    public apiServiceContentMapGetAllGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceContentsMapDto>>('get',`${this.basePath}/api/ServiceContentMap/GetAll`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceContentMapGetByIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceContentsMapDto>;
    public apiServiceContentMapGetByIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceContentsMapDto>>;
    public apiServiceContentMapGetByIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceContentsMapDto>>;
    public apiServiceContentMapGetByIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceContentsMapDto>('get',`${this.basePath}/api/ServiceContentMap/GetById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param contentNamesToRemove 
     * @param serviceName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceContentMapUnMapContentFromServiceDelete(contentNamesToRemove?: Array<string>, serviceName?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiServiceContentMapUnMapContentFromServiceDelete(contentNamesToRemove?: Array<string>, serviceName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiServiceContentMapUnMapContentFromServiceDelete(contentNamesToRemove?: Array<string>, serviceName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiServiceContentMapUnMapContentFromServiceDelete(contentNamesToRemove?: Array<string>, serviceName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contentNamesToRemove) {
            contentNamesToRemove.forEach((element) => {
                queryParameters = queryParameters.append('contentNamesToRemove', <any>element);
            })
        }
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/ServiceContentMap/UnMapContentFromService`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceContentMapUpdatePut(body?: ServiceContentMap, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiServiceContentMapUpdatePut(body?: ServiceContentMap, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiServiceContentMapUpdatePut(body?: ServiceContentMap, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiServiceContentMapUpdatePut(body?: ServiceContentMap, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/ServiceContentMap/Update`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceContentMapUpdateRangePut(body?: EditServceContentMapByLists, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiServiceContentMapUpdateRangePut(body?: EditServceContentMapByLists, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiServiceContentMapUpdateRangePut(body?: EditServceContentMapByLists, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiServiceContentMapUpdateRangePut(body?: EditServceContentMapByLists, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/ServiceContentMap/UpdateRange`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
